import { ReactNode } from "react";

type Props = {
  children: ReactNode;
};

export default function PhoneBody({ children }: Props) {
  return (
    <div className="relative size-full bg-no-repeat bg-cover rounded-[3.125rem] overflow-hidden">
      {children}
    </div>
  );
}
